import { useState, useEffect, Fragment } from 'react';
// import _, { isLength } from 'lodash';
// import axios from 'axios';
import AboutAuth from '../../UI/AboutAuth';
import Backdrop from '../../Backdrop/Backdrop';
import Modal from '../../Modal/Modal';
import FilesUploadAction from '../../FileUploadAction/FilesUploadAction';

import { useStore } from '../../../hook-store/store';

import './TranscriberFileUpload.css';

function TranscriberFileUpload(props) {

  const { 
    uploadFiles,
    setShowUploadModal,
    uploadApp,
  } = props;

  const [store, dispatch] = useStore();
  // console.log('store-App.tsx', store);
  const { isAuth } = store.uiStore;
  const { 
      mlSpeechCurrentAudioData,
      mlSpeechText,
  } = store.mlSpeechStore;


  const [fileTextContent, setFileTextContent] = useState('');

  // useEffect(() => {
  //   if (gLoading) {
  //     setIsLoading(true);
  //   } else {
  //     setIsLoading(false);
  //   }
  // },[gLoading]);


  useEffect(() => {
    if (uploadFiles && uploadFiles[0]) {
      getFileTextHandler(uploadFiles[0]);
    }
  },[uploadFiles]);

  const getFileTextHandler = async (file) => {
    try {
      const fileUrl = URL.createObjectURL(file);

      const response = await fetch(fileUrl);

      const resData = await response.text();

      if (resData) {
        setFileTextContent(resData);
      }

      // console.log(response, resData);

    } catch(err) {
      console.log(err);
    }
  }

  let displayText = fileTextContent;

  if (fileTextContent && fileTextContent.length > 100) {
    displayText = fileTextContent.slice(0, 100) + '....';
  }

  // console.log(uploadFiles)
  let transcriberFileUploadBody;

  transcriberFileUploadBody = (
    <div>
      <Backdrop 
        zIndex={'95'}
        onCancel={() => { 
          setShowUploadModal(false);
        }}
      />
      <Modal
        onClose={() => {
          setShowUploadModal(false);
        }}
      >
        <div>
          <div className='transcriberUploadSection'>
            <div className='transcriberUploadTitle'>
              Upload text to Kura Storage
            </div>
          </div>
          <div className='transcriberUploadSection'>
            <div>text content</div>

            <div className='transcriberUploadText'
              // style={{border: "1px solid red" ,whiteSpace: "pre-wrap"}}
            >
              {displayText} 
            </div>

            {/* {mlSpeechText.length} */}
          </div>
          <br/>

          {isAuth && (
            <div className='transcriberUploadSection'>
              <FilesUploadAction 
                uploadFiles={uploadFiles}
                // uploadApp={'audioTranscriber'}
                uploadApp={uploadApp}
              />
            </div>
          )}
          {!isAuth && (
            <div className='transcriberUploadSection'>
              <AboutAuth />
            </div>
          )}
        </div>
      </Modal>
    </div>
  )


  
  return (
    <Fragment>
      {transcriberFileUploadBody}
    </Fragment>
  );
}

export default TranscriberFileUpload;
